<!-- components/Footer.svelte -->
<script>
  import { Link } from "svelte-routing";
  import { t } from "../libs/i18n";

</script>


<!-- ======= Footer ======= -->
<footer id="footer">

  <div class="container d-md-flex py-4">

    <div class="me-md-auto text-center text-md-start">
      <div class="copyright">
        <Link to="/term">{$t("footer.term")}</Link>
      </div>
      <div class="copyright">
        <Link to="/privacy">{$t("footer.privacy")}</Link>
      </div>
      <div class="copyright">
        &copy; Copyright <strong><span>{$t("footer.companyName")}</span></strong>. All Rights Reserved
      </div>
    </div>
  </div>
</footer><!-- End Footer -->